export default __webpack_public_path__ + "static/media/laptop-mobile.d551ca67.svg";